var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLnkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16339 0 0 7.16339 0 16C0 24.8366 7.16339 32 16 32C24.8366 32 32.0001 24.8366 32.0001 16C32 7.16339 24.8365 0 16 0ZM11.7312 23.7353H8.21821V12.3859H11.7312V23.7353ZM9.95795 10.8996C8.81065 10.8996 7.88057 9.96193 7.88057 8.80545C7.88057 7.64883 8.81078 6.71123 9.95795 6.71123C11.1051 6.71123 12.0352 7.64883 12.0352 8.80545C12.0353 9.962 11.1052 10.8996 9.95795 10.8996ZM24.896 23.7353H21.4001V17.7778C21.4001 16.1438 20.7794 15.2317 19.4874 15.2317C18.0812 15.2317 17.3466 16.1817 17.3466 17.7778V23.7353H13.9773V12.3859H17.3466V13.9145C17.3466 13.9145 18.3601 12.0397 20.7667 12.0397C23.1733 12.0397 24.8961 13.5091 24.8961 16.549L24.896 23.7353Z",
    fill: "#112F4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnkedin);
export default __webpack_public_path__ + "static/media/lnkedin.cb85e89ed3bd0e0916ba0f639dade957.svg";
export { ForwardRef as ReactComponent };